import React from 'react';

const PaymentStatus: React.FC = () => {
  // Status indicators with their respective colors
  const statuses = [
    { label: 'Paid', color: 'bg-green-600' },
    { label: 'Pending', color: 'bg-amber-500' },
    { label: 'Overdue', color: 'bg-red-600' },
    { label: 'Write Off', color: "bg-teal-600" }
  ];

  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-3 mt-0">Payment Status</h3>
      <div className="bg-cream rounded-md p-3 flex flex-wrap gap-3 items-start border border-gray-100">
        {statuses.map((status, index) => (
          <div key={index} className="flex items-center">
            <div className={`h-4 w-4 rounded-full ${status.color} mr-2`}></div>
            <span className="text-gray-700">{status.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentStatus;